import { useEffect, useLayoutEffect, useRef } from 'react';
import {
  clearSharedTripMarkerAfterNextFrame,
  markSharedTripUnpainted,
  watchSharedTripPaint,
} from '@/lib/sharedTripPaintWatch';

/**
 * Paint diagnostics for the shared-trip page. `placeCount` is null until the
 * trip has loaded. Returns the ref for the trip title, which the watch checks.
 */
export function useSharedTripPaintWatch(loading: boolean, placeCount: number | null) {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const tripRenderStartedAt = useRef<number | null>(null);
  if (placeCount !== null && tripRenderStartedAt.current === null) tripRenderStartedAt.current = performance.now();

  useEffect(() => {
    if (loading) markSharedTripUnpainted();
  }, [loading]);

  // Keyed on loading + count, not the trip object: a re-fetch must not restart the watch.
  useLayoutEffect(() => {
    if (loading) return;
    if (placeCount === null) return clearSharedTripMarkerAfterNextFrame();
    return watchSharedTripPaint(() => titleRef.current, placeCount, tripRenderStartedAt.current ?? performance.now());
  }, [loading, placeCount]);

  return titleRef;
}
